module.exports = __webpack_public_path__ + "./images/tier8.jpg";